import { IFileUpload, ImageDimensions, PhotoData } from '@ui-app/models/common.models';
import { Observable } from 'rxjs';

export abstract class FileUploadService implements IFileUpload {
    abstract uploadFile(file: File, uploadUrl: string): Observable<PhotoData>;

    getImageDimensions(file: File): Promise<ImageDimensions> {
        const fileAsDataURL = URL.createObjectURL(file);
        return new Promise(resolve => {
            const img = new Image();
            img.onload = () => {
                URL.revokeObjectURL(img.src);
                resolve({
                    width: img.width,
                    height: img.height,
                });
            };
            img.src = fileAsDataURL;
        });
    }
}
